/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Cache = require('./Cache');

module.exports = _Cache.Cache;


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/bootstrap.js
// module id = 357
// module chunks = 0